import React, { useState } from 'react';
import Icon from '../Icon';
import { t } from '../../i18n';
import iconType from '../../utils/icontype';
import s from './Map.module.scss';
import Link from 'next/link';
import classNames from 'classnames';

const PopupCarousel = ({ items = [], showTag }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const handlePrevious = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? items.length - 1 : prevIndex - 1
        );
    };

    const handleNext = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === items.length - 1 ? 0 : prevIndex + 1
        );
    };

    const currentItem = items[currentIndex];
    const showCurrentTag = ['city', 'country'].includes(
        currentItem?.coordinateLevel
    );
    const tagTextKey =
        currentItem?.coordinateLevel === 'country'
            ? 'map.tagTextCountry'
            : 'map.tagText';

    return (
        <div className={s.PopupCarousel}>
            <div
                className={s.PopupCarouselContentWrapper}
                // style={showTag ? { paddingTop: '24px' } : {}}
            >
                {showCurrentTag && (
                    <div className={s.PopupCarouselTagWrapper}>
                        <div className={s.PopupCarouselTag}>
                            <span className={s.PopupCarouselTagText}>
                                {t(tagTextKey)}
                            </span>
                        </div>
                    </div>
                )}

                <div className={s.PopupCarouselContent}>
                    <span className={s.PopupCarouselLabel}>
                        {currentItem?.category || ''}
                    </span>
                    <h3 className={s.PopupCarouselTitle}>{currentItem.name}</h3>
                    <p className={s.PopupCarouselDescription}>
                        {currentItem.fullAddress || currentItem.address}
                    </p>
                    <div className={s.PopupCarouselIcon}>
                        <Icon name={iconType(currentItem.category)} />
                    </div>
                </div>
            </div>
            <div className={s.PopupCarouselLinkWrapper}>
                <Link
                    className={classNames(s.PopupButton, s.PopupLinkButton)}
                    href={currentItem.url}>
                    See more company details
                </Link>
            </div>
            <div className={s.PopupCarouselButtonWrapper}>
                <button
                    className={s.PopupCarouselButton}
                    onClick={handlePrevious}>
                    {t('map.previous')}
                </button>
                <span className={s.PopupCarouselCounter}>
                    {t('map.locationCount', {
                        current: currentIndex + 1,
                        total: items.length,
                    })}
                </span>
                <button className={s.PopupCarouselButton} onClick={handleNext}>
                    {t('map.next')}
                </button>
            </div>
        </div>
    );
};

export default PopupCarousel;
